import { useRef } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Action from "../redux/Action";
import { setIsChooseFileOpen, setIsChooseProductOpen } from "../redux/Reducer";

const OpenFile = () => {
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const closeChooseFile = () => {
    dispatch(setIsChooseFileOpen(false));
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeChooseFile();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleChooseImage = () => {
    Action.uploadMedia(dispatch, { showMedia: true });
    closeChooseFile();
  };

  const handleChooseProduct = () => {
    dispatch(setIsChooseProductOpen(true));
    closeChooseFile();
  };

  return (
    <div
      ref={modalRef}
      className="rounded bg-[#F5F5F5] w-[180px] absolute bottom-[70px]"
    >
      <div
        onClick={handleChooseImage}
        className="w-full px-4 py-2 border-b border-[#DADADA] flex items-center gap-2 cursor-pointer hover:bg-gray-200 hover:rounded-t"
      >
        <img
          src={process.env.REACT_APP_ASSETS_IMAGE + "choose-image-file.svg"}
          alt="Choose Image File"
        />
        <p className="font-normal text-[12px] leading-[100%] text-[#4E5554]">
          Image / Videos
        </p>
      </div>
      <div
        onClick={handleChooseProduct}
        className="w-full px-4 py-2 flex items-center gap-2 cursor-pointer hover:bg-gray-200 hover:rounded-b"
      >
        <img
          src={process.env.REACT_APP_ASSETS_IMAGE + "choose-product-file.svg"}
          alt="Choose Image File"
        />
        <p className="font-normal text-[12px] leading-[100%] text-[#4E5554]">
          Product
        </p>
      </div>
    </div>
  );
};

export default OpenFile;
